import { Box } from '@material-ui/core';
import { Currency, ProductExternal } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { useScreen } from '@/hooks/useScreen';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

import { LoanStatusExternalMap } from '../../../maps/LoanStatusExternal.map';
import { TimeIntervalSelector } from './MetricAggregateViews/components/TimeIntervalSelector';
import { MetricAggregateViews } from './MetricAggregateViews/MetricAggregateViews';
import { useLiveMetrics } from './shared/hooks/useLiveMetrics';
import { useMetricsScope } from './shared/hooks/useMetricsScope';
import { useTimeInterval } from './shared/hooks/useTimeInterval';

interface MetricsProductExternalProps {
  productExternal: ProductExternal;
}

const MetricsProductExternal = ({ productExternal }: MetricsProductExternalProps) => {
  const { sm } = useScreen(); //FIXME: provoking a re-render
  const { timeInterval, setTimeInterval } = useTimeInterval();
  useLiveMetrics(useMetricsScope());

  const [loanStatusExternal] = useState(LoanStatusExternalMap.fromProductExternal(productExternal));

  return (
    <Box display={'flex'} flexDirection={sm ? 'row' : 'column-reverse'}>
      <Box flexGrow={1}>
        <MetricAggregateViews
          currency={Currency.EUR}
          timeInterval={timeInterval}
          loanStatusExternal={loanStatusExternal}
          productExternal={[productExternal]}
        />
      </Box>
      <Box margin={sm ? '0 0 0 24px' : '0 auto 24px'} position={sm ? 'block' : 'relative'}>
        <TimeIntervalSelector
          type={sm ? 'button' : 'select'}
          timeInterval={timeInterval}
          setTimeInterval={setTimeInterval}
        />
      </Box>
    </Box>
  );
};

export const MetricsProductExternalModule = withPermissionsModule(MetricsProductExternal);
